import React, { useEffect, useState } from 'react'
import { CardContainer_Props } from './interface'
import { PlaceholderWrapper, Placeholder } from './GameBoardStyles'
import { Card } from '../card/Card'
import { CardWrapper } from '../card/CardStyles'
import { colors } from 'lib/colors'

export default function DealerContainer({
  cardsList,
  deal,
  dealOut,
  calculateDelay,
  showResult,
  winPositions,
  noAnimate,
  delay,
}: CardContainer_Props) {
  return (
    <PlaceholderWrapper className='player'>
      {cardsList.map((card: any, id: any) => (
        <Placeholder key={id} zIndex={7 - id}>
          {deal && (
            <CardWrapper
              deal={deal}
              flipCard={false}
              dealOut={dealOut}
              delay={delay}
            >
              <Card
                noAnimate={noAnimate}
                card={card}
                deal={deal}
                animDelay={calculateDelay(id)}
                background={
                  showResult && winPositions[id] === '1'
                    ? colors.secondary
                    : colors.cardWhite
                }
              />
            </CardWrapper>
          )}
        </Placeholder>
      ))}
    </PlaceholderWrapper>
  )
}
